var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container container_40 portfolio-details" },
    [
      _vm.token
        ? [
            _c("div", { staticClass: "portfolio-details__description" }, [
              _c("p", { staticClass: "text_large text_bold" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.i18n.lbl_description()) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "text_small text_margin" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.sale.details.short_description) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "detail-row",
              {
                staticClass: "text_margin",
                attrs: { prop: _vm.i18n.com_name() }
              },
              [_c("company-name-getter", { attrs: { id: _vm.token.owner } })],
              1
            ),
            _vm._v(" "),
            _c("detail-row", {
              staticClass: "text_margin",
              attrs: {
                prop: _vm.i18n.sale_investment_project_name(),
                value: _vm.sale.details.name
              }
            }),
            _vm._v(" "),
            _c("detail-row", {
              staticClass: "text_margin",
              attrs: { prop: _vm.i18n.lbl_token_code(), value: _vm.token.code }
            }),
            _vm._v(" "),
            _c("detail-row", {
              staticClass: "text_margin",
              attrs: {
                prop: _vm.i18n.lbl_current_price(),
                value: _vm.token.price + " " + _vm.token.convertedAsset
              }
            }),
            _vm._v(" "),
            _c("detail-row", {
              staticClass: "text_margin",
              attrs: {
                prop: _vm.i18n.lbl_max_issuance(),
                value: _vm.token.max + " " + _vm.token.code
              }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fbf80d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fbf80d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/portfolio/Portfolio.Details.vue
// module id = tm1V
// module chunks = 1